var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartLineCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 20.1665L2.57401 11.7405C0.575675 9.38653 0.680175 5.85553 2.89759 3.6372C3.96094 2.57388 5.38702 1.95195 6.88977 1.89619C8.39252 1.84043 9.86078 2.35495 11 3.33653C12.1381 2.35495 13.6051 1.8397 15.107 1.89404C16.6089 1.94838 18.0348 2.56829 19.099 3.62955C20.1631 4.69082 20.7869 6.11503 20.8454 7.6168C20.9038 9.11857 20.3926 10.587 19.4141 11.7277L11 20.1665ZM18.0235 10.5333C18.7008 9.74349 19.0546 8.72694 19.014 7.68731C18.9735 6.64768 18.5416 5.66178 17.8048 4.92714C17.0681 4.19249 16.081 3.76338 15.0412 3.72578C14.0015 3.68818 12.986 4.04486 12.1981 4.72437L11 5.75837L9.80192 4.72437C9.01405 4.04486 7.99851 3.68818 6.95877 3.72578C5.91903 3.76338 4.93191 4.19249 4.19518 4.92714C3.45845 5.66178 3.02654 6.64768 2.98599 7.68731C2.94544 8.72694 3.29924 9.74349 3.97651 10.5333L4.08101 10.6543L11 17.5742L17.919 10.6543L18.0235 10.5333Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartLineCustom);
export default __webpack_public_path__ + "static/media/heart-line-custom.709c03c3.svg";
export { ForwardRef as ReactComponent };